import { CommunityManagement } from '../interfaces/ICommunityManagement';

export const KUNUNU_REPLY_MAX_CHARACTERS = 400;

export const getReplyMaxCharacters = (
  settings: CommunityManagement,
  platform: string
): number | undefined => {
  if (settings.limitReplyTo400Characters && platform.toLowerCase() === 'kununu') {
    return KUNUNU_REPLY_MAX_CHARACTERS;
  }

  return undefined;
};
